import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";

@Injectable()
export class RegistrationsNestApi {
  private service: string = '';
  private model: string = 'registrations';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }

  public dataOnboarding(payload: { type: string }): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'dataOnboarding';
    const params: any = payload;
    const urlParams: any = {}
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, null, null, false);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/registrations.api.ts